<template>
  <div class="lp-shape-toolbar" v-if="value">
    <template v-if="!changeContentProtection">
      <v-icon small class="ml-2 mr-3">mdi-format-color-fill</v-icon>
      <div class="lp-shape-toolbar-color">
        <preset-input-color
          :value="value.data.style.stroke"
          @input="value.data.style.stroke = $event"
          :small="true"></preset-input-color>
      </div>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn flat v-on="on">
            <v-icon small>mdi-format-line-weight</v-icon>
            <v-icon small>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-text class="lp-shape-toolbar__slider">
            <v-slider
              v-model="value.data.style.strokeWidth"
              thumb-label="always"
              thumb-size="28"
              hide-details
              :min="1"
              :max="50"></v-slider>
          </v-card-text>
        </v-card>
      </v-menu>
      <div class="overflow-button">
        <v-overflow-btn
        :items="lineStyles"
        label="Line style"
        item-text="text"
        v-model="value.data.style.lineStyle">
          <template v-slot:selection><span>Line style</span></template>
      </v-overflow-btn>
      </div>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn flat v-on="on">
            <v-icon small>mdi-format-line-spacing mdi-rotate-270</v-icon>
            <v-icon small>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-text class="lp-shape-toolbar__slider">
            <v-slider
              v-model="value.data.style.spacesSize"
              thumb-label="always"
              thumb-size="28"
              hide-details
              :min="1"
              :max="50"></v-slider>
          </v-card-text>
        </v-card>
      </v-menu>
      <v-menu offset-y v-if="value.data.style.lineStyle === 'dashed'">
        <template v-slot:activator="{ on }">
          <v-btn flat v-on="on">
            <v-icon small>mdi-format-line-style</v-icon>
            <v-icon small>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-text class="lp-shape-toolbar__slider">
            <v-slider
              v-model="value.data.style.pointsSize"
              thumb-label="always"
              thumb-size="28"
              hide-details
              :min="1"
              :max="50"></v-slider>
          </v-card-text>
        </v-card>
      </v-menu>
    </template>
    <div v-else style="color: #7d7d7d">
      <v-icon small class="ml-2 mr-3">mdi-lock-outline</v-icon>
      Change content protection enabled
    </div>
  </div>
</template>

<script>
import PresetInputColor from "../../components/slides/styles/PresetInputColor"
import { PToolbarAction } from "plant-common"
export default {
  name: "ShapeLineToolbar",
  props: ["value"],
  components: {
    PresetInputColor,
    PToolbarAction
  },
  computed: {
    changeContentProtection() {
      return this.value.protection.data
    }
  },
  data(){
    return {
      lineStyles: ['solid', 'dashed', 'dotted']
    }
  }
}
</script>

<style>
.lp-shape-toolbar,
.lp-shape-toolbar-color {
  display: flex;
}
.lp-shape-toolbar-color {
  align-items: center;
}
.overflow-button {
  width: 150px;
  height: 40px;
}
</style>
